<template>
  <p>
    <span> {{ renderText(textNote) }}</span>
    <span v-if="!isShowFull && renderText(textNote).length > 46"
      >... <span class="text-info" @click="showAll()">Xem thêm</span></span
    >
    <span v-if="isShowFull && renderText(textNote).length > 46"
      ><span class="text-info pl-2" @click="hideLess()">Ẩn bớt</span></span
    >
  </p>
</template>

<script>
export default {
  props: {
    textNote: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isShowFull: false,
    };
  },
  methods: {
    renderText(text) {
      const render = text.join('. ');
      if (this.isShowFull) {
        return render;
      }
      return render.length > 46 ? render.slice(0, 47) : render;
    },
    showAll() {
      this.isShowFull = true;
    },
    hideLess() {
      this.isShowFull = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-info {
  color: #1187CA;
}
</style>
